module.exports = __webpack_public_path__ + "static/media/61QTs18YRcL._AC_UX679_.88cb7962.jpg";